export default "__VITE_ASSET__BTCHq1$q__"